module.exports = __webpack_public_path__ + "img/养老中心.990efa8d.png";